import { Component, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/shared/services/auth.service';
import { RegistrationService } from 'src/shared/services/registration.service';
import { ResponseService } from 'src/shared/services/response-service.service';
import { SchoolProgramService } from 'src/shared/services/school-program.service';
import { TranslateService } from 'src/shared/services/translate.service';

@Component({
  selector: 'app-payment-student',
  templateUrl: './payment-student.component.html',
  styleUrl: './payment-student.component.scss'
})
export class PaymentStudentComponent {
  @ViewChild('paymentModal', {static: true}) paymentModal: NgbModalRef;
  @ViewChild('paymentLogsModal') paymentLogsModal: TemplateRef<any>;

  loading = false;
  loadingVa = false;
  subs: Subscription;
  paramForm: FormGroup;
  registrationPaymentDetail: any;
  scoreRange: any;
  participants: any;
  displayedColumns: any;
  subscription: Subscription;
  warningText: any;
  columnsToDisplay: string[] = ['activity_name', 'student_name', 'is_paid', 'payment_generated', 'total_fee', 'payment_date', 'payment_notes', 'payment_logs', 'action'];
  data: any[] = [];
  role: any;
  students: any[] = [];
  studentId: any;
  selectedRegistrationPaymentId: number | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private registService: RegistrationService,
    private rpService: ResponseService,
    private auth: AuthService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.translate.load('registration', 'extracurricular', 'activity');
    this.initForm();
    this.auth.loadPermissions(true);
    this.translate.load('extracurricular', 'registration');
    this.role = this.auth.current().roles;
    if (this.role.includes('ORANGTUA') || this.role.includes('PARENT')) {
      this.getChildrenData();
    } else {
      this.studentId = this.auth.current().user.student_id;
      this.students.push({student_id: this.studentId, student_name: this.auth.current().user.fullname});
      this.getStudentPaymentList();
    }
  }

  getChildrenData(studentId: any = null) {
    this.registService.getChildren().subscribe(
      (response: any) => {
        if (response.error === 0) {
          response.result.data.forEach((element: any) => {
            this.students.push(element);
          });
          this.getStudentPaymentList();
        } else {
          this.rpService.showAddError('Failed to get children data. Please try again.');
        }
      },
      (error) => {
        this.rpService.showAddError();
      }
    );
  }

  initForm() {
    this.paramForm = new FormGroup({
      
    });
  }


  getStudentPaymentList() {
    if (this.subs) {
      this.subs.unsubscribe();
    }
    this.loading = true;
    this.subs = this.registService.getStudentActivityPayment({student: this.students}).subscribe({
      next: (res) => {
        if (res.status) {
          this.data = res.data;
          this.loading = false;
        } else {
          this.rpService.showAddError();
          this.loading = false;
        }
      },
      error: (res) => {
        this.rpService.showAddError();
        this.loading = false;
      }
    });
  }

  onShowPayment(data: any) {
    this.loadingVa = true;
    this.modalService.open(this.paymentModal, {
      size: 'md',
    });
    this.openPaymentSectionVa(data);
  }

  openPaymentSectionVa(data: any) {
    this.registService.getStudentRegistrationPaymentDetailByActivity(data.registration_payment_id).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.registrationPaymentDetail = response.data;
        } else {
          this.registrationPaymentDetail = null;
          this.rpService.showAddError('Failed to get payment data.');
        }
        this.loadingVa = false;
      },
      error: (error: any) => {
        this.rpService.showAddError('Failed to get payment data.');
        this.loadingVa = false;
      }
    })
  }

  openPaymentLogsModal(registrationPaymentId: number) {
    this.selectedRegistrationPaymentId = registrationPaymentId;
    this.modalService.open(this.paymentLogsModal, {
      size: 'xl',
      scrollable: true
    });
  }

}
